import { FC } from "react";
import { ExplainerExpression } from "../../types/explainer";
import { ExplainerPointsList } from "../molecules";
import { ExplainerImage, ExplainerTitle } from "../atoms";

export const ExplainerContent: FC<{ data: ExplainerExpression }> = ({
  data,
}) => {
  return (
    <div className="overflow-y-auto">
      <ExplainerTitle title={data.title ?? ""} />
      <ExplainerPointsList points={data.points} />
      <div className="grid place-items-center">
        <ExplainerImage data={data} />
      </div>
    </div>
  );
};
